"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaTableau = void 0;

var _react = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _MfaTableauEntete = require("./MfaTableauEntete");

var _MfaTableauPanneauFiltre = require("./MfaTableauPanneauFiltre");

var _travailleurTableau = _interopRequireDefault(require("../../travailleurTableau"));

var _utilitaires = require("../../utils/utilitaires");

var _MfaIconeAnnuler = require("./MfaIconeAnnuler");

require("semantic-ui-css/semantic.min.css");

var _MfaContexte = require("../MfaContexte");

var _utilitaires2 = require("../../utils/utilitaires.requete");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaTableau = /*#__PURE__*/function (_Component) {
  _inherits(MfaTableau, _Component);

  var _super = _createSuper(MfaTableau);

  function MfaTableau(props) {
    var _this;

    _classCallCheck(this, MfaTableau);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "callbackClient", void 0);

    _defineProperty(_assertThisInitialized(_this), "cartePresistance", {
      tri: function tri() {
        return null;
      },
      filtre: function filtre() {},
      filtreIndicateur: function filtreIndicateur() {},
      indexPage: function indexPage() {
        return 0;
      },
      termeRecherche: function termeRecherche() {
        return null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "doitEffacerFiltres", void 0);

    _defineProperty(_assertThisInitialized(_this), "doitMettreDonneesAJour", void 0);

    _defineProperty(_assertThisInitialized(_this), "elementTableau", void 0);

    _defineProperty(_assertThisInitialized(_this), "identifiant", void 0);

    _defineProperty(_assertThisInitialized(_this), "limiteChoix", 100);

    _defineProperty(_assertThisInitialized(_this), "estMonte", false);

    _defineProperty(_assertThisInitialized(_this), "panneauATrier", void 0);

    _defineProperty(_assertThisInitialized(_this), "trancheChoix", 20);

    _defineProperty(_assertThisInitialized(_this), "travailleur", void 0);

    _defineProperty(_assertThisInitialized(_this), "triPanneau", void 0);

    _defineProperty(_assertThisInitialized(_this), "minuteurRecherche", void 0);

    _defineProperty(_assertThisInitialized(_this), "valeurANePasTrier", []);

    _this.state = {
      enChargement: !_this.props.donnees,
      quantite: 10,
      total: (0, _utilitaires.estDefini)(_this.props.donnees, 'length') ? _this.props.donnees.length : 0,
      indexPage: 0,
      panneauOuvert: null,
      choixFiltre: {},
      choixFiltreEnChargement: [],
      choixFiltreClient: {},
      termeRechercheFiltre: {},
      totalFiltre: {},
      cacheFiltreValeurUnique: {},
      donnees: _this.props.donnees
    };
    Object.assign(_this.state, _this.obtenirEtatInitial());

    _this.verifierConfigurations();

    _this.initialiserTravailleurWeb();

    _this.identifiant = (0, _utilitaires.guid)();
    document.body.addEventListener('click', _this.corpsClique.bind(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(MfaTableau, [{
    key: "corpsClique",
    value: function corpsClique(evennement) {
      if (!this.estMonte) {
        return;
      }

      var target = evennement.target;

      while (target && target.tagName !== 'BODY') {
        if (target === this.elementTableau) {
          return;
        }

        target = target.parentElement;
      }

      this.setState({
        panneauOuvert: null
      });
    }
  }, {
    key: "initialiserTravailleurWeb",
    value: function initialiserTravailleurWeb() {
      if (!this.travailleur) {
        var code = _travailleurTableau.default.toString();

        var blob = new Blob(['(' + code + ')()']);
        this.travailleur = new Worker(URL.createObjectURL(blob));
        this.travailleur.addEventListener('message', this.traiterMessageTravailleur.bind(this));
      }
    }
  }, {
    key: "obtenirEtatInitial",
    value: function obtenirEtatInitial() {
      var etatPersiteJson = window.sessionStorage.getItem(this.props.id || this.identifiant);
      var etatPersiste = etatPersiteJson ? JSON.parse(etatPersiteJson) : null;
      return {
        tri: etatPersiste && etatPersiste.tri ? etatPersiste.tri : this.props.triInitial || {},
        filtre: etatPersiste && etatPersiste.filtre ? etatPersiste.filtre : this.props.filtreInitial || {},
        filtreIndicateur: etatPersiste && etatPersiste.filtreIndicateur ? etatPersiste.filtreIndicateur : this.props.filtreIndicateurInitial || {},
        indexPage: etatPersiste && etatPersiste.indexPage !== undefined ? etatPersiste.indexPage : this.props.indexPageInitial || 0,
        termeRecherche: etatPersiste && (0, _utilitaires.nestPasNulOuVide)(etatPersiste.termeRecherche) ? etatPersiste.termeRecherche : this.props.termeRechercheInitial || null
      };
    }
  }, {
    key: "verifierConfigurations",
    value: function verifierConfigurations() {
      var _this$props = this.props,
          generateurAddresse = _this$props.generateurAddresse,
          generateurAddresseValeursUniques = _this$props.generateurAddresseValeursUniques,
          nonFiltrable = _this$props.nonFiltrable,
          donnees = _this$props.donnees;

      if (donnees) {
        return;
      } else if (!generateurAddresse) {
        console.warn("Aucune données ou source serveur fourni pour la table.");
      } else if (!nonFiltrable && !generateurAddresseValeursUniques) {
        console.warn("Pour une table serveur, vous devez fournir une source de valeurs uniques.");
      }
    }
  }, {
    key: "obtenirContexteSAI",
    value: function obtenirContexteSAI() {
      if ((0, _utilitaires.estDefini)(this.context) && (0, _utilitaires.estDefini)(this.context.contexteSAI)) {
        return this.context.contexteSAI;
      }

      return null;
    }
  }, {
    key: "mettrePanneauATrierSiChoixExiste",
    value: function mettrePanneauATrierSiChoixExiste() {
      var choix = this.state.choixFiltre[this.panneauATrier];

      if (choix) {
        this.triPanneau = true;
        this.panneauATrier = null;
        return true;
      }
    }
  }, {
    key: "estConfigurerServeur",
    value: function estConfigurerServeur() {
      var generateurAddresse = this.props.generateurAddresse;
      return !!generateurAddresse;
    }
  }, {
    key: "estNonActionableBase",
    value: function estNonActionableBase(colonne, propriete) {
      var valeurProps = this.props[propriete];
      var valeur = colonne[propriete];
      var estSimple = this.props.simple === true;
      return estSimple && valeur !== false || valeurProps === true && valeur !== false || valeur === true;
    }
  }, {
    key: "estNonFiltrable",
    value: function estNonFiltrable(colonne) {
      var _this$state = this.state,
          enChargement = _this$state.enChargement,
          panneauOuvert = _this$state.panneauOuvert;

      if (enChargement && panneauOuvert !== colonne.nom) {
        return true;
      }

      return this.estNonActionableBase(colonne, 'nonFiltrable');
    }
  }, {
    key: "estNonTriable",
    value: function estNonTriable(colonne) {
      if (this.state.enChargement) {
        return true;
      }

      return this.estNonActionableBase(colonne, 'nonTriable');
    }
  }, {
    key: "estNonRecherchable",
    value: function estNonRecherchable() {
      var _this$props2 = this.props,
          simple = _this$props2.simple,
          nonRecherchable = _this$props2.nonRecherchable;
      var estSimple = simple === true;
      return estSimple && nonRecherchable !== false || nonRecherchable === true;
    }
  }, {
    key: "traiterMessageTravailleur",
    value: function traiterMessageTravailleur(evennement) {
      var _this2 = this;

      var _evennement$data = evennement.data,
          type = _evennement$data.type,
          donnees = _evennement$data.donnees,
          nomColonne = _evennement$data.nomColonne;

      if (type === 'valeurs-filtre') {
        var _this$state2 = this.state,
            choixFiltreClient = _this$state2.choixFiltreClient,
            totalFiltre = _this$state2.totalFiltre,
            choixFiltreEnChargement = _this$state2.choixFiltreEnChargement,
            choixFiltre = _this$state2.choixFiltre;
        choixFiltreClient[nomColonne] = donnees;
        totalFiltre = totalFiltre || {};
        totalFiltre[nomColonne] = donnees.length;
        choixFiltre = choixFiltre || {};
        choixFiltre[nomColonne] = donnees.slice(0, Math.min(donnees.length, this.trancheChoix));
        choixFiltreEnChargement = choixFiltreEnChargement.filter(function (nom) {
          return nom !== nomColonne;
        });
        this.setState({
          choixFiltre: choixFiltre,
          choixFiltreClient: choixFiltreClient,
          choixFiltreEnChargement: choixFiltreEnChargement,
          totalFiltre: totalFiltre
        });
      } else {
        this.setState({
          donnees: donnees,
          total: donnees && donnees.length,
          enChargement: false
        }, function () {
          if (_this2.callbackClient) {
            _this2.callbackClient();

            _this2.callbackClient = null;
          }
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.estMonte = true;

      if (this.estConfigurerServeur()) {
        this.mettreDonnesAJour();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.estMonte = false;
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (this.triPanneau) {
        this.triPanneau = false;
      } else {
        if (nextState.panneauOuvert !== this.state.panneauOuvert) {
          if (!this.mettrePanneauATrierSiChoixExiste()) {
            this.panneauATrier = nextState.panneauOuvert;
          }
        }

        if (this.panneauATrier) {
          this.mettrePanneauATrierSiChoixExiste();
        }
      }

      if (!nextProps.donnees && this.props.donnees || !nextProps.generateurAddresse && this.props.generateurAddresse) {
        this.doitEffacerFiltres = true;
      }

      if (nextProps.donnees && this.props.donnees !== nextProps.donnees || !nextProps.donnees && this.props.donnees && nextProps.generateurAddresse) {
        this.doitMettreDonneesAJour = true;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;

      var nouvelEtat = this.doitEffacerFiltres || this.doitMettreDonneesAJour ? {
        enChargement: true,
        total: 0,
        indexPage: 0
      } : null;

      if (this.doitMettreDonneesAJour) {
        this.doitMettreDonneesAJour = false;
        Object.assign(nouvelEtat, {
          donnees: null
        });
      }

      if (this.doitEffacerFiltres) {
        this.doitEffacerFiltres = false;
        Object.assign(nouvelEtat, {
          filtre: {},
          choixFiltre: {},
          choixFiltreClient: {},
          choixFiltreEnChargement: [],
          totalFiltre: {},
          tri: this.estConfigurerServeur() ? this.state.tri : this.props.triInitial || {}
        });
      }

      var doitMettreAJourEtat = !!nouvelEtat;

      if (doitMettreAJourEtat) {
        this.setState(nouvelEtat, function () {
          _this3.mettreDonnesAJour('filtrer-ajout');
        });
      }

      var _this$state3 = this.state,
          choixFiltre = _this$state3.choixFiltre,
          panneauOuvert = _this$state3.panneauOuvert,
          choixFiltreEnChargement = _this$state3.choixFiltreEnChargement;

      if (!panneauOuvert) {
        this.valeurANePasTrier = [];
        return;
      }

      if (choixFiltreEnChargement.indexOf(panneauOuvert) !== -1) {
        return;
      }

      var choix = choixFiltre[panneauOuvert];

      if (!choix) {
        choixFiltreEnChargement = (0, _utilitaires.valeursUniques)(choixFiltreEnChargement.concat([panneauOuvert]));
        this.setState({
          choixFiltreEnChargement: choixFiltreEnChargement
        }, function () {
          _this3.mettreValeursFiltreAJour(panneauOuvert);
        });
      }
    }
  }, {
    key: "mettreDonnesAJour",
    value: function () {
      var _mettreDonnesAJour = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(type, callback) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.persisterEtat();

                if (this.estConfigurerServeur()) {
                  this.mettreDonneesAJourServeur(callback);
                } else {
                  this.mettreDonneesAJourClient(type, callback);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mettreDonnesAJour(_x, _x2) {
        return _mettreDonnesAJour.apply(this, arguments);
      }

      return mettreDonnesAJour;
    }()
  }, {
    key: "mettreDonneesAJourServeur",
    value: function () {
      var _mettreDonneesAJourServeur = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(callback) {
        var addresse, options, headers, contexteSAI, reponse, resultat;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                addresse = this.props.generateurAddresse(this.state.indexPage, this.state.quantite, this.state.tri, this.obtenirFiltreCombine(), (0, _utilitaires.trimmerSiNonNul)(this.state.termeRecherche));
                options = {
                  mode: 'cors',
                  headers: {
                    'Access-Control-Allow-Origin': '*'
                  }
                };
                headers = options.headers;
                contexteSAI = this.obtenirContexteSAI();

                if ((0, _utilitaires.estDefini)(contexteSAI)) {
                  headers.Authentication = contexteSAI;
                }

                _context2.next = 7;
                return fetch(addresse, options);

              case 7:
                reponse = _context2.sent;

                if (!(0, _utilitaires2.afficherDialogueAuthentication)(reponse, this.context)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return");

              case 10:
                _context2.next = 12;
                return reponse.json();

              case 12:
                resultat = _context2.sent;
                this.setState({
                  donnees: resultat.charge,
                  total: resultat.total !== null ? resultat.total : this.state.total,
                  enChargement: false
                }, function () {
                  if (callback) {
                    callback();
                  }
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function mettreDonneesAJourServeur(_x3) {
        return _mettreDonneesAJourServeur.apply(this, arguments);
      }

      return mettreDonneesAJourServeur;
    }()
  }, {
    key: "mettreDonneesAJourClientBase",
    value: function mettreDonneesAJourClientBase(type, donnees, filtre, termeRecherche, nomColonne, termeRechercheColonne, callback) {
      this.callbackClient = callback;
      var tri = this.state.tri;
      var colonnes = this.props.colonnes;
      var colonneTri = tri && colonnes.find(function (colonne) {
        return colonne.nom === tri.nom;
      });
      var fonctionTri = colonneTri && colonneTri.fonctionTri;
      var fonctionsFiltres = colonnes.reduce(function (objet, colonne) {
        var fonctionFiltre = colonne.fonctionFiltre;

        if (fonctionFiltre && typeof fonctionFiltre === 'function') {
          objet[colonne.nom] = fonctionFiltre.toString();
        }

        return objet;
      }, {});
      var fonctionsValeurs = colonnes.reduce(function (objet, colonne) {
        var formatteur = colonne.formatteur;

        if (formatteur && typeof formatteur === 'function') {
          objet[colonne.nom] = formatteur.toString();
        }

        return objet;
      }, {});
      this.travailleur.postMessage({
        type: type,
        donnees: donnees,
        tri: tri,
        filtre: filtre,
        termeRechercheColonne: (0, _utilitaires.trimmerSiNonNul)(termeRechercheColonne),
        nomsColonnes: colonnes.map(function (colonne) {
          return colonne.nom;
        }),
        fonctionsFiltres: fonctionsFiltres,
        fonctionsValeurs: fonctionsValeurs,
        nomColonne: nomColonne,
        termeRecherche: (0, _utilitaires.trimmerSiNonNul)(termeRecherche),
        fonctionTri: fonctionTri && fonctionTri.toString()
      });
    }
  }, {
    key: "mettreDonneesAJourClient",
    value: function mettreDonneesAJourClient(type, callback) {
      var donneesTotales = this.props.donnees;
      var _this$state4 = this.state,
          donnees = _this$state4.donnees,
          termeRecherche = _this$state4.termeRecherche;
      var donneesATraiter;

      if (type === 'tri' || type === 'filtrer-retrait') {
        donneesATraiter = donnees;
      } else {
        donneesATraiter = donneesTotales;
      }

      var filtre = this.obtenirFiltreCombine();
      this.mettreDonneesAJourClientBase(type, donneesATraiter, filtre, termeRecherche, null, null, callback);
    }
  }, {
    key: "mettreValeursFiltreAJour",
    value: function () {
      var _mettreValeursFiltreAJour = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(nomColonne) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.estConfigurerServeur()) {
                  this.mettreValeursFiltreAJourServeur(nomColonne);
                } else {
                  this.mettreValeursFiltreAJourClient(nomColonne);
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function mettreValeursFiltreAJour(_x4) {
        return _mettreValeursFiltreAJour.apply(this, arguments);
      }

      return mettreValeursFiltreAJour;
    }()
  }, {
    key: "mettreValeursFiltreAJourBase",
    value: function mettreValeursFiltreAJourBase(nomColonne, callback) {
      var _this$state5 = this.state,
          choixFiltre = _this$state5.choixFiltre,
          choixFiltreEnChargement = _this$state5.choixFiltreEnChargement,
          totalFiltre = _this$state5.totalFiltre,
          termeRechercheFiltre = _this$state5.termeRechercheFiltre,
          termeRecherche = _this$state5.termeRecherche,
          filtreIndicateur = _this$state5.filtreIndicateur;
      var choixColonnes = choixFiltre ? choixFiltre[nomColonne] || null : null;

      if (choixColonnes && choixColonnes.length >= this.limiteChoix) {
        choixFiltreEnChargement = choixFiltreEnChargement.filter(function (nom) {
          return nom !== nomColonne;
        });
        this.setState({
          choixFiltreEnChargement: choixFiltreEnChargement
        });
        return;
      }

      var filtreUtilise = this.obtenirFiltreCombine();
      delete filtreUtilise[nomColonne];

      if (filtreIndicateur[nomColonne]) {
        filtreUtilise[nomColonne] = filtreIndicateur[nomColonne];
      }

      choixColonnes = choixColonnes || [];
      var termeRechercheColonne = termeRechercheFiltre ? (0, _utilitaires.trimmerSiNonNul)(termeRechercheFiltre[nomColonne]) : null;
      termeRecherche = (0, _utilitaires.trimmerSiNonNul)(termeRecherche);
      callback(termeRechercheColonne, filtreUtilise, termeRecherche, choixFiltre, choixFiltreEnChargement, totalFiltre, choixColonnes);
    }
  }, {
    key: "mettreValeursFiltreAJourServeur",
    value: function () {
      var _mettreValeursFiltreAJourServeur = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(nomColonne) {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.mettreValeursFiltreAJourBase(nomColonne, /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(termeRechercheColonne, filtreUtilise, termeRecherche, choixFiltre, choixFiltreEnChargement, totalFiltre, choixColonnes) {
                    var dernierChoix, addresse, options, contexteSAI, reponse, resultat;
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            dernierChoix = choixColonnes.length ? choixColonnes[choixColonnes.length - 1] : null;
                            addresse = _this4.props.generateurAddresseValeursUniques(nomColonne, dernierChoix, termeRechercheColonne, Math.min(_this4.trancheChoix, _this4.limiteChoix - choixColonnes.length), filtreUtilise, termeRecherche);
                            options = {};
                            contexteSAI = _this4.obtenirContexteSAI();

                            if ((0, _utilitaires.estDefini)(contexteSAI)) {
                              options.headers = {
                                'Authentication': contexteSAI
                              };
                            }

                            _context4.next = 7;
                            return fetch(addresse, options);

                          case 7:
                            reponse = _context4.sent;
                            _context4.next = 10;
                            return reponse.json();

                          case 10:
                            resultat = _context4.sent;

                            if (!(0, _utilitaires2.afficherDialogueAuthentication)(resultat, _this4.context)) {
                              _context4.next = 13;
                              break;
                            }

                            return _context4.abrupt("return");

                          case 13:
                            choixColonnes = choixColonnes.concat(resultat.charge);
                            choixFiltre[nomColonne] = choixColonnes;
                            totalFiltre[nomColonne] = resultat.total;
                            choixFiltreEnChargement = choixFiltreEnChargement.filter(function (nom) {
                              return nom !== nomColonne;
                            });

                            _this4.setState({
                              choixFiltreEnChargement: choixFiltreEnChargement,
                              choixFiltre: choixFiltre,
                              totalFiltre: totalFiltre
                            });

                          case 18:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x6, _x7, _x8, _x9, _x10, _x11, _x12) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function mettreValeursFiltreAJourServeur(_x5) {
        return _mettreValeursFiltreAJourServeur.apply(this, arguments);
      }

      return mettreValeursFiltreAJourServeur;
    }()
  }, {
    key: "mettreValeursFiltreAJourClient",
    value: function () {
      var _mettreValeursFiltreAJourClient = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(nomColonne) {
        var _this5 = this;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.mettreValeursFiltreAJourBase(nomColonne, function (termeRechercheColonne, filtreUtilise, termeRecherche, choixFiltre, choixFiltreEnChargement, totalFiltre, choixColonnes) {
                  var choixFiltreClient = _this5.state.choixFiltreClient;

                  if (choixFiltreClient && choixFiltreClient[nomColonne]) {
                    var choixColonneClient = choixFiltreClient[nomColonne];
                    totalFiltre = totalFiltre || {};
                    choixFiltreEnChargement = choixFiltreEnChargement.filter(function (nom) {
                      return nom !== nomColonne;
                    });
                    choixFiltre[nomColonne] = choixColonneClient.slice(0, Math.min(Math.min(_this5.limiteChoix, choixColonneClient.length), choixColonnes.length + _this5.trancheChoix));
                    totalFiltre[nomColonne] = choixColonneClient.length;

                    _this5.setState({
                      choixFiltre: choixFiltre,
                      choixFiltreEnChargement: choixFiltreEnChargement,
                      totalFiltre: totalFiltre
                    });

                    return;
                  }

                  var donneesTotales = _this5.props.donnees;

                  _this5.mettreDonneesAJourClientBase('valeurs-filtre', donneesTotales, filtreUtilise, termeRecherche, nomColonne, termeRechercheColonne);
                });

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function mettreValeursFiltreAJourClient(_x13) {
        return _mettreValeursFiltreAJourClient.apply(this, arguments);
      }

      return mettreValeursFiltreAJourClient;
    }()
  }, {
    key: "effacerAutreFiltre",
    value: function effacerAutreFiltre(nomColonne, choixFiltre, totalFiltre, choixFiltreClient) {
      [choixFiltre, totalFiltre, choixFiltreClient].forEach(function (objet) {
        return objet && Object.keys(objet).filter(function (propriete) {
          return propriete !== nomColonne;
        }).forEach(function (propriete) {
          return delete objet[propriete];
        });
      });
    }
  }, {
    key: "persisterEtat",
    value: function persisterEtat() {
      var etatPersiste = {
        filtreIndicateur: this.state.filtreIndicateur,
        filtre: this.state.filtre,
        tri: this.state.tri,
        indexPage: this.state.indexPage,
        termeRecherche: this.state.termeRecherche
      };
      var etatStr = JSON.stringify(etatPersiste);
      window.sessionStorage.setItem(this.props.id || 'mfa-table', etatStr);
    }
  }, {
    key: "obtenirFiltreCombine",
    value: function obtenirFiltreCombine() {
      var _this$state6 = this.state,
          filtre = _this$state6.filtre,
          filtreIndicateur = _this$state6.filtreIndicateur;
      filtre = filtre || {};
      filtreIndicateur = filtreIndicateur || {};
      var filtreCombine = {};
      (0, _utilitaires.valeursUniques)(Object.keys(filtre).concat(Object.keys(filtreIndicateur))).forEach(function (propriete) {
        var valeursFiltre = filtre[propriete] || [];
        var valeursFiltreIndicateur = filtreIndicateur[propriete] || [];
        filtreCombine[propriete] = (0, _utilitaires.valeursUniques)(valeursFiltre.concat(valeursFiltreIndicateur));
      });
      return filtreCombine;
    }
  }, {
    key: "obtenirCellulePourDonnee",
    value: function obtenirCellulePourDonnee(donnee) {
      var _this6 = this;

      return this.props.colonnes.map(function (colonne) {
        return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table.Cell, {
          key: colonne.nom,
          style: colonne.styleCellule
        }, _this6.extraireValeur(donnee, colonne));
      });
    }
  }, {
    key: "extraireValeur",
    value: function extraireValeur(donnee, colonne) {
      var valeur = donnee[colonne.nom];

      if (valeur === undefined) {
        valeur = '';
      }

      var valeurTexte = colonne.formatteur ? colonne.formatteur(valeur, donnee) : valeur;
      var valeurFormatte = this.state.enChargement ? valeurTexte : this.formatterValeurPourTermeRecherche(valeurTexte);
      return colonne.render ? colonne.render(valeurFormatte, donnee) : valeurFormatte;
    }
  }, {
    key: "formatterValeurPourTermeRecherche",
    value: function formatterValeurPourTermeRecherche(valeur) {
      var termeRecherche = this.state.termeRecherche;
      termeRecherche = termeRecherche && termeRecherche.trim ? termeRecherche.trim() : termeRecherche;

      if (!(0, _utilitaires.nestPasNulOuVide)(termeRecherche)) {
        return valeur;
      }

      var valeurStr = (0, _utilitaires.estDefini)(valeur) && valeur.toString();
      var match = (0, _utilitaires.estDefini)(valeurStr) ? valeurStr.match(new RegExp(termeRecherche, 'i')) : null;

      if (!match) {
        return valeur;
      }

      var trouveur = new RegExp(termeRecherche, "gi");
      var indexe = 0;
      var lotElements = [];
      var indexCle = 0;

      while (match = trouveur.exec(valeurStr)) {
        if (match.index > indexe) {
          var texteNonRecherche = valeurStr.substring(indexe, match.index);

          var SpanNonRecherche = /*#__PURE__*/_react.default.createElement("span", {
            key: indexCle++
          }, " ", texteNonRecherche);

          lotElements.push(SpanNonRecherche);
        }

        var texteRecherche = valeurStr.substr(match.index, match[0].length);

        var SpanRecherche = /*#__PURE__*/_react.default.createElement("span", {
          key: indexCle++,
          className: "mfa-tableau-valeur-recherche"
        }, texteRecherche);

        lotElements.push(SpanRecherche);
        indexe = match.index + match[0].length;
      }

      if (indexe < valeurStr.length) {
        var texteRestant = valeurStr.substring(indexe);

        var SpanRestant = /*#__PURE__*/_react.default.createElement("span", {
          key: indexCle++
        }, texteRestant);

        lotElements.push(SpanRestant);
      }

      return lotElements;
    }
  }, {
    key: "changementPage",
    value: function changementPage(evennement, args) {
      var _this7 = this;

      this.setState({
        enChargement: this.estConfigurerServeur(),
        indexPage: args.activePage - 1
      }, function () {
        if (_this7.props.apresChangementPage) {
          _this7.props.apresChangementPage(_this7.state.indexPage);
        }

        if (_this7.estConfigurerServeur()) {
          _this7.mettreDonnesAJour();
        }
      });
    }
  }, {
    key: "obtenirDonneesPaginees",
    value: function obtenirDonneesPaginees() {
      var _this$state7 = this.state,
          donnees = _this$state7.donnees,
          indexPage = _this$state7.indexPage,
          quantite = _this$state7.quantite;
      var debut = Math.max(0, indexPage * quantite);
      var fin = Math.max(0, (indexPage + 1) * quantite);
      return donnees && donnees.slice(Math.min(donnees.length, debut), Math.min(donnees.length, fin));
    }
  }, {
    key: "obtenirDonnees",
    value: function obtenirDonnees() {
      if (this.doitMettreDonneesAJour) {
        return null;
      } else if (!this.estConfigurerServeur()) {
        return this.obtenirDonneesPaginees();
      }

      return this.state.donnees;
    }
  }, {
    key: "obtenirTri",
    value: function obtenirTri(nomColonne) {
      var tri = this.state.tri;

      if (!tri || tri.nom !== nomColonne) {
        return null;
      }

      return tri;
    }
  }, {
    key: "surcliqueEntete",
    value: function surcliqueEntete(nomColonne, evennement) {
      evennement.stopPropagation();
      this.setState({
        panneauOuvert: this.state.panneauOuvert === nomColonne ? null : nomColonne
      });
    }
  }, {
    key: "surCliqueNomColonne",
    value: function surCliqueNomColonne(colonne, evennement) {
      var _this8 = this;

      evennement.stopPropagation();
      var tri = this.state.tri;
      var nouveauTri = {
        nom: colonne.nom
      };
      nouveauTri.descendant = tri && tri.nom === nouveauTri.nom ? !tri.descendant : false;
      this.setState({
        tri: nouveauTri,
        enChargement: true
      }, function () {
        _this8.mettreDonnesAJour('tri');
      });
    }
  }, {
    key: "indicateurActive",
    value: function indicateurActive(evennement, valeur, fonctionFiltre) {
      var _this9 = this;

      if (!fonctionFiltre) {
        return;
      }

      var _this$state8 = this.state,
          filtreIndicateur = _this$state8.filtreIndicateur,
          filtre = _this$state8.filtre;

      var _fonctionFiltre = fonctionFiltre(evennement, valeur, filtreIndicateur, filtre),
          _fonctionFiltre2 = _slicedToArray(_fonctionFiltre, 2),
          filtreIndicateurMisAJour = _fonctionFiltre2[0],
          filtreMisAjour = _fonctionFiltre2[1];

      filtre = filtreMisAjour || filtre;
      filtreIndicateur = filtreIndicateurMisAJour || filtreIndicateur;
      this.setState({
        filtre: filtre,
        filtreIndicateur: filtreIndicateur,
        choixFiltreClient: {},
        choixFiltre: {},
        totalFiltre: {},
        enChargement: true,
        indexPage: 0
      }, function () {
        _this9.mettreDonnesAJour('filtrer-ajout');
      });
    }
  }, {
    key: "changementRecherche",
    value: function changementRecherche(evennement, valeur) {
      var _this10 = this;

      var terme = valeur ? valeur.value : null;

      if (this.minuteurRecherche !== undefined) {
        clearTimeout(this.minuteurRecherche);
      }

      this.setState({
        termeRecherche: terme,
        enChargement: true,
        choixFiltreClient: {},
        indexPage: 0,
        choixFiltre: {},
        totalFiltre: {}
      }, function () {
        _this10.minuteurRecherche = setTimeout(function () {
          _this10.mettreDonnesAJour('recherche');
        }, 500);
      });
    }
  }, {
    key: "changementRechercheFiltre",
    value: function changementRechercheFiltre(nomColonne, evennement, valeur) {
      var _this11 = this;

      var terme = valeur ? valeur.value : null;

      if (this.minuteurRecherche !== undefined) {
        clearTimeout(this.minuteurRecherche);
      }

      var _this$state9 = this.state,
          termeRechercheFiltre = _this$state9.termeRechercheFiltre,
          choixFiltreEnChargement = _this$state9.choixFiltreEnChargement,
          choixFiltreClient = _this$state9.choixFiltreClient,
          choixFiltre = _this$state9.choixFiltre;
      termeRechercheFiltre[nomColonne] = terme;
      choixFiltreClient[nomColonne] = null;
      choixFiltre[nomColonne] = null;
      this.valeurANePasTrier = [];
      choixFiltreEnChargement = (0, _utilitaires.valeursUniques)(choixFiltreEnChargement.concat([nomColonne]));
      this.setState({
        choixFiltreClient: choixFiltreClient,
        choixFiltre: choixFiltre,
        termeRechercheFiltre: termeRechercheFiltre,
        choixFiltreEnChargement: choixFiltreEnChargement
      }, function () {
        _this11.minuteurRecherche = setTimeout(function () {
          _this11.mettreValeursFiltreAJour(nomColonne);
        }, 500);
      });
    }
  }, {
    key: "updateChoixPanneauOuvert",
    value: function updateChoixPanneauOuvert() {
      var _this12 = this;

      var _this$state10 = this.state,
          panneauOuvert = _this$state10.panneauOuvert,
          choixFiltre = _this$state10.choixFiltre,
          choixFiltreEnChargement = _this$state10.choixFiltreEnChargement;

      if (panneauOuvert === null) {
        return;
      }

      var choix = choixFiltre[panneauOuvert];

      if (!choix && choixFiltreEnChargement.indexOf(panneauOuvert) === -1) {
        choixFiltreEnChargement = (0, _utilitaires.valeursUniques)(choixFiltreEnChargement.concat([panneauOuvert]));
        this.setState({
          choixFiltreEnChargement: choixFiltreEnChargement
        }, function () {
          _this12.mettreValeursFiltreAJour(panneauOuvert);
        });
      }
    }
  }, {
    key: "obtenirChoixFiltre",
    value: function obtenirChoixFiltre(nomColonne) {
      var _this13 = this;

      var _this$state11 = this.state,
          panneauOuvert = _this$state11.panneauOuvert,
          choixFiltre = _this$state11.choixFiltre,
          choixFiltreEnChargement = _this$state11.choixFiltreEnChargement,
          filtre = _this$state11.filtre;

      if (panneauOuvert !== nomColonne) {
        return null;
      }

      var choix = choixFiltre[nomColonne];
      var valeurs = filtre[nomColonne] || [];
      var choixComplet = choix ? valeurs.filter(function (valeur) {
        return choix.indexOf(valeur) === -1;
      }).concat(choix) : null;

      if (choixComplet) {
        choixComplet.sort(function (a, b) {
          var valeurA = valeurs.find(function (valeur) {
            return valeur === a;
          });
          var valeurB = valeurs.find(function (valeur) {
            return valeur === b;
          });
          valeurA = _this13.valeurANePasTrier.some(function (valeur) {
            return valeur === valeurA;
          }) ? null : valeurA;
          valeurB = _this13.valeurANePasTrier.some(function (valeur) {
            return valeur === valeurB;
          }) ? null : valeurB;
          var valeurATrie = (0, _utilitaires.enleverAccent)(valeurA);
          var valeurBTrie = (0, _utilitaires.enleverAccent)(valeurB);

          if (!valeurATrie && valeurBTrie) {
            return 1;
          } else if (valeurATrie && !valeurBTrie) {
            return -1;
          } else if (!valeurATrie && !valeurBTrie) {
            var aTrie = (0, _utilitaires.enleverAccent)(a);
            var bTrie = (0, _utilitaires.enleverAccent)(b);
            return aTrie === bTrie ? 0 : aTrie > bTrie ? 1 : -1;
          }

          return valeurATrie === valeurBTrie ? 0 : valeurATrie > valeurBTrie ? 1 : -1;
        });
      }

      return choixComplet;
    }
  }, {
    key: "obtenirValeursFiltre",
    value: function obtenirValeursFiltre(nomColonne) {
      var _this$state12 = this.state,
          panneauOuvert = _this$state12.panneauOuvert,
          filtre = _this$state12.filtre;

      if (panneauOuvert !== nomColonne) {
        return null;
      }

      return filtre[nomColonne];
    }
  }, {
    key: "obtenirTotalFiltre",
    value: function obtenirTotalFiltre(nomColonne) {
      var _this$state13 = this.state,
          panneauOuvert = _this$state13.panneauOuvert,
          totalFiltre = _this$state13.totalFiltre;

      if (panneauOuvert !== nomColonne) {
        return null;
      }

      return totalFiltre[nomColonne];
    }
  }, {
    key: "obtenirTermeRechercheFiltre",
    value: function obtenirTermeRechercheFiltre(nomColonne) {
      var _this$state14 = this.state,
          termeRechercheFiltre = _this$state14.termeRechercheFiltre,
          panneauOuvert = _this$state14.panneauOuvert;

      if (panneauOuvert !== nomColonne) {
        return null;
      }

      return termeRechercheFiltre[nomColonne];
    }
  }, {
    key: "obtenirClasseEntete",
    value: function obtenirClasseEntete(nomColonne) {
      var _this$state15 = this.state,
          filtre = _this$state15.filtre,
          panneauOuvert = _this$state15.panneauOuvert;
      var classes = [];

      if (nomColonne === panneauOuvert) {
        classes.push('ouvert');
      }

      if (filtre[nomColonne] && filtre[nomColonne].length) {
        classes.push('filtre');
      }

      return classes.join(' ');
    }
  }, {
    key: "obtenirCompteFiltre",
    value: function obtenirCompteFiltre(nomColonne) {
      var filtre = this.state.filtre;
      var valeurs = filtre[nomColonne] || [];
      return valeurs.length ? valeurs.length.toString() : '';
    }
  }, {
    key: "surCaseFiltreCliquee",
    value: function surCaseFiltreCliquee(nomColonne, valeur, ajoutee) {
      var _this14 = this;

      var _this$state16 = this.state,
          filtre = _this$state16.filtre,
          choixFiltre = _this$state16.choixFiltre,
          totalFiltre = _this$state16.totalFiltre,
          choixFiltreClient = _this$state16.choixFiltreClient;
      var valeurs = filtre[nomColonne];

      if (!valeurs) {
        valeurs = [];
      }

      if (ajoutee) {
        valeurs = (0, _utilitaires.valeursUniques)(valeurs.concat([valeur]));
        this.valeurANePasTrier = (0, _utilitaires.valeursUniques)(this.valeurANePasTrier.concat([valeur]));
      } else {
        delete choixFiltreClient[nomColonne];
        valeurs = valeurs.filter(function (valeurPresente) {
          return valeurPresente !== valeur;
        });
        this.valeurANePasTrier = this.valeurANePasTrier.filter(function (valeurPresente) {
          return valeurPresente !== valeur;
        });
      }

      this.effacerAutreFiltre(nomColonne, choixFiltre, totalFiltre, choixFiltreClient);
      var ajout = valeurs.length > 1 || valeurs.length === 0;
      filtre[nomColonne] = valeurs;
      this.setState({
        filtre: filtre,
        choixFiltre: choixFiltre,
        choixFiltreClient: choixFiltreClient,
        totalFiltre: totalFiltre,
        indexPage: 0,
        enChargement: true
      }, function () {
        _this14.mettreDonnesAJour("filtrer-".concat(ajout ? 'ajout' : 'retrait'));
      });
    }
  }, {
    key: "surChargeurFiltreVisible",
    value: function surChargeurFiltreVisible(nomColonne) {
      var _this15 = this;

      var choixFiltreEnChargement = this.state.choixFiltreEnChargement;

      if (choixFiltreEnChargement.indexOf(nomColonne) !== -1) {
        return;
      }

      this.setState({
        choixFiltreEnChargement: (0, _utilitaires.valeursUniques)(choixFiltreEnChargement.concat([nomColonne]))
      }, function () {
        _this15.mettreValeursFiltreAJour(nomColonne);
      });
    }
  }, {
    key: "effacerToutLesFiltres",
    value: function effacerToutLesFiltres() {
      var _this16 = this;

      var filtre = this.state.filtre;
      filtre = filtre || {};
      var proprietes = Object.keys(filtre);
      this.props.colonnes.map(function (colonne) {
        return colonne.nom;
      }).filter(function (nom) {
        return proprietes.indexOf(nom) !== -1;
      }).forEach(function (nom) {
        return delete filtre[nom];
      });
      this.setState({
        filtre: filtre,
        choixFiltreClient: {},
        choixFiltre: {},
        totalFiltre: {},
        enChargement: true
      }, function () {
        _this16.mettreDonnesAJour('filtrer-ajout');
      });
    }
  }, {
    key: "effacerValeursFiltre",
    value: function effacerValeursFiltre(nomColonne) {
      var _this17 = this;

      var _this$state17 = this.state,
          filtre = _this$state17.filtre,
          termeRechercheFiltre = _this$state17.termeRechercheFiltre,
          totalFiltre = _this$state17.totalFiltre,
          choixFiltre = _this$state17.choixFiltre,
          choixFiltreClient = _this$state17.choixFiltreClient;
      this.effacerAutreFiltre(nomColonne, choixFiltre, totalFiltre, choixFiltreClient);
      var filtreColonne = filtre[nomColonne];
      var filtreExiste = filtreColonne && filtreColonne.length > 0;
      delete filtre[nomColonne];
      var termeRechercheColonne = termeRechercheFiltre[nomColonne];

      if (termeRechercheColonne) {
        delete choixFiltreClient[nomColonne];
        delete choixFiltre[nomColonne];
      }

      delete termeRechercheFiltre[nomColonne];
      this.setState({
        choixFiltre: choixFiltre,
        choixFiltreClient: choixFiltreClient,
        filtre: filtre,
        enChargement: filtreExiste
      }, function () {
        if (filtreExiste) {
          _this17.mettreDonnesAJour('filtrer-ajout', function () {
            return termeRechercheColonne ? _this17.mettreValeursFiltreAJour(nomColonne) : null;
          });
        } else if (!!termeRechercheColonne) {
          _this17.mettreValeursFiltreAJour(nomColonne);
        }
      });
    }
  }, {
    key: "renderBoutonsAnnuler",
    value: function renderBoutonsAnnuler() {
      var _this18 = this;

      var boutonsAnnuler = [];

      if (this.state.termeRecherche) {
        boutonsAnnuler.push( /*#__PURE__*/_react.default.createElement(_MfaIconeAnnuler.MfaIconeAnnuler, {
          key: "recherche",
          nomIcone: "search",
          surClique: function surClique() {
            return _this18.changementRecherche();
          }
        }));
      }

      var filtre = this.state.filtre;

      if (filtre && Object.keys(filtre).some(function (propriete) {
        return filtre[propriete] && filtre[propriete].length;
      })) {
        boutonsAnnuler.push( /*#__PURE__*/_react.default.createElement(_MfaIconeAnnuler.MfaIconeAnnuler, {
          key: "filtre",
          nomIcone: "filter",
          surClique: function surClique() {
            return _this18.effacerToutLesFiltres();
          }
        }));
      }

      return boutonsAnnuler;
    }
  }, {
    key: "renderIndicateurs",
    value: function renderIndicateurs() {
      var _this19 = this;

      var index = 0;
      var className = this.props.afficherIndicateurPleineLargeur ? null : 'mfa-panneau-indicateur';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-ib"
      }, !this.estNonRecherchable() ? /*#__PURE__*/_react.default.createElement(_semanticUiReact.Search, {
        className: "mfa-ib",
        input: {
          placeholder: 'Rechercher...'
        },
        open: false,
        value: this.state.termeRecherche || '',
        onSearchChange: this.changementRecherche.bind(this)
      }) : null, /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-ib mfa-panneau-indicateur-boutons"
      }, this.renderBoutonsAnnuler())), /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-ib"
      }, this.props.indicateurs ? this.props.indicateurs.map(function (indicateur) {
        var Composante = indicateur.element;
        var fonctionFiltre = indicateur.fonctionFiltre;
        var props = (0, _utilitaires.filtrerProprietesObjet)(indicateur, ['element', 'fonctionFiltre', 'obtenirProprieteActive']);
        var obtenirProprieteActive = indicateur.obtenirProprieteActive;
        var proprieteActive = obtenirProprieteActive && typeof obtenirProprieteActive === 'function' && obtenirProprieteActive(_this19.state.filtreIndicateur, _this19.state.filtre);

        if (proprieteActive) {
          Object.assign(props, proprieteActive);
        }

        return /*#__PURE__*/_react.default.createElement(Composante, _extends({
          disabled: _this19.state.enChargement,
          key: 'indic-' + index++,
          onClick: function onClick(evennement, valeur) {
            return _this19.indicateurActive(evennement, valeur, fonctionFiltre);
          }
        }, props));
      }) : null));
    }
  }, {
    key: "renderCorps",
    value: function renderCorps() {
      var _this20 = this;

      var messageTableauVide = (0, _utilitaires.estDefini)(this.props.messageTableauVide) ? this.props.messageTableauVide : 'Aucune donnée à afficher';
      var donnees = this.obtenirDonnees();

      if (!donnees || !donnees.length) {
        return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table.Row, {
          className: "mfa-tableau-rangee-vide"
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table.Cell, {
          colSpan: this.props.colonnes.length
        }, !this.state.enChargement ? messageTableauVide : null));
      }

      var k = 0;
      return donnees.map(function (donnee) {
        return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table.Row, {
          key: 'row' + k++
        }, _this20.obtenirCellulePourDonnee(donnee));
      });
    }
  }, {
    key: "renderEntetes",
    value: function renderEntetes() {
      var _this21 = this;

      return this.props.colonnes.map(function (colonne) {
        return /*#__PURE__*/_react.default.createElement(_MfaTableauEntete.MfaTableauEntete, _extends({
          classe: _this21.obtenirClasseEntete(colonne.nom),
          surClique: function surClique(evennement) {
            return _this21.surCliqueNomColonne(colonne, evennement);
          },
          tri: _this21.obtenirTri(colonne.nom),
          triable: !_this21.estNonTriable(colonne),
          key: colonne.nom,
          proprietesEntete: {
            onClick: function onClick(evennement) {
              return _this21.surcliqueEntete(colonne.nom, evennement);
            }
          }
        }, colonne), !_this21.estNonFiltrable(colonne) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
          className: "mfa-tableau-icone-filtre",
          name: "filter"
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "mfa-tableau-icone-filtre-indicateur"
        }, _this21.obtenirCompteFiltre(colonne.nom)), /*#__PURE__*/_react.default.createElement(_MfaTableauPanneauFiltre.MfaTableauPanneauFiltre, {
          effacerValeurs: function effacerValeurs(evennement) {
            _this21.effacerValeursFiltre(colonne.nom);
          },
          fermerPanneau: function fermerPanneau(evennement) {
            _this21.setState({
              panneauOuvert: null
            });
          },
          choixOrdonne: _this21.triPanneau,
          surCaseCliquee: function surCaseCliquee(valeur, ajoutee) {
            return _this21.surCaseFiltreCliquee(colonne.nom, valeur, ajoutee);
          },
          surChargeurFiltreVisible: function surChargeurFiltreVisible() {
            return _this21.surChargeurFiltreVisible(colonne.nom);
          },
          changementRecherche: function changementRecherche(evennement, valeur) {
            return _this21.changementRechercheFiltre(colonne.nom, evennement, valeur);
          },
          termeRecherche: _this21.obtenirTermeRechercheFiltre(colonne.nom),
          choix: _this21.obtenirChoixFiltre(colonne.nom),
          valeurs: _this21.obtenirValeursFiltre(colonne.nom),
          total: _this21.obtenirTotalFiltre(colonne.nom),
          colonne: colonne,
          visible: _this21.state.panneauOuvert === colonne.nom,
          limiteChoix: _this21.limiteChoix
        })) : null);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this22 = this;

      var pagine = this.state.total > this.state.quantite;
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(element) {
          return _this22.elementTableau = element;
        },
        onClick: function onClick() {
          return _this22.setState({
            panneauOuvert: null
          });
        }
      }, this.renderIndicateurs(), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dimmer.Dimmable, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table, _extends({
        className: "mfa-tableau"
      }, this.props.proprietesTable), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table.Header, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table.Row, null, this.renderEntetes())), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table.Body, null, this.renderCorps(), this.props.children), pagine ? /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table.Footer, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table.Cell, {
        colSpan: this.props.colonnes.length
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Pagination, {
        disabled: this.state.enChargement,
        activePage: this.state.indexPage + 1,
        onPageChange: this.changementPage.bind(this),
        totalPages: Math.ceil(this.state.total / this.state.quantite)
      })))) : null), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dimmer, {
        active: this.props.enChargement || this.state.enChargement,
        className: "gradateur-apparition".concat(pagine ? ' pagine' : ''),
        inverted: true
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Loader, null))));
    }
  }]);

  return MfaTableau;
}(_react.Component);

exports.MfaTableau = MfaTableau;

_defineProperty(MfaTableau, "contextType", _MfaContexte.MfaContexte);